export default __webpack_public_path__ + "static/media/enterButton.ebe69f2d.svg";